import { useEffect } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import withHandymanCredentials from "../../../components/auth/hocs/withWorkerCredentials";
import LoadingContent from "../../../components/common/loaders/LoadingContent";
import ProfileFormSection from "../../../components/forms/profile-form/ProfileFormSection";
import AppPage from "../../../components/layout/AppPage";
import useMutableQuery from "../../../hooks/use-mutatable-query";
import { useApiClients } from "../../../hooks/use-api-clients";
import { TWorkerSignInData } from "../../../_model/schemas-and-types/repo-schemas";

const HandymanProfileRoute = (props: TWorkerSignInData) => {
  const navigate = useNavigate();

  const { handymanRepo } = useApiClients();
  const queryClient = useQueryClient();
  const handymanRes = useMutableQuery({
    queryKey: ["handyman", props.handyman.id],
    queryFn: () => handymanRepo.fetchHandyman(props.handyman.id),
    initialData: () => {
      return queryClient.getQueryData("signInStateProfile");
    },
  });

  useEffect(() => {
    if (
      handymanRes.query.isError ||
      (!handymanRes.query.isLoading && !handymanRes.query.data)
    ) {
      navigate("/partner");
    }
  }, [
    handymanRes.query.isLoading,
    handymanRes.query.isError,
    handymanRes.query.data,
    navigate,
  ]);

  return (
    <LoadingContent
      loading={handymanRes.query.isLoading && !handymanRes.query.data}
      renderContentSeparately
    >
      <AppPage
        className="h-full p-2 lg:p-4"
        headerProps={{
          heading: "Profil",
        }}
      >
        {handymanRes.query.data && (
          <ProfileFormSection
            user={handymanRes.query.data}
            loading={handymanRes.query.isLoading}
            updateProfileInfo={async (handyman) => {
              handymanRes.mutate({
                callback: () => handymanRepo.updateProfileInfo(handyman),
                optimisticUpdate: handyman,
              });
            }}
          />
        )}
      </AppPage>
    </LoadingContent>
  );
};

export default withHandymanCredentials(HandymanProfileRoute);
